<template>
  <div>
    <li
      aria-level="2"
      role="treeitem"
      v-for="locale in locales"
      :key="locale"
      @click="changeLocale(locale)"
    >
      <div class="slds-tree__item">
        <CountryFlag
          :country="locale"
          size="small"
          :class="{'selected': locale === localValue}"
        />
        <span
          class="slds-tree__item-label slds-truncate flag-text"
          title="Tree Item"
        >{{$t(`locales.${locale}`)}}</span>
      </div>
    </li>
  </div>
</template>
<script>
import CountryFlag from 'vue-country-flag'

export default {
  components: {
    CountryFlag
  },
  data () {
    return {
      localValue: '',
      locales: []
    }
  },
  async created () {
    // const locales = await this.$store.dispatch('userManagement/getSettings')
    // this.locales = locales.locale
    // if (this.value === 'en') {
    //   this.localValue = 'gb'
    // } else {
    //   this.localValue = this.value
    // }

    const settings = await this.$store.dispatch('settings/getSettings')
    let { locale } = settings

    locale = locale.map(item => item === 'en' ? 'gb' : item)
    this.locales = locale

    if (this.value === 'en') {
      this.localValue = 'gb'
    } else {
      this.localValue = this.value
    }
  },
  methods: {
    changeLocale (locale) {
      if (locale === 'gb') {
        locale = 'en'
      }
      this.$emit('input', locale)
      this.$store.dispatch('session/changeLocale', locale)
    }
  },
  props: {
    value: String
  },
  watch: {
    value (value) {
      if (value === 'en') {
        this.localValue = 'gb'
      } else {
        this.localValue = value
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.flag-text {
  margin-left: 5px;
}

span.flag {
  opacity: 0.5;

  &.selected {
    opacity: 1;
  }
}
</style>
